import GeneralInformation from './GeneralInformation';
import Divider from '@mui/material/Divider';
import TransactionOverview from './TransactionOverview';
import UseOfFunds from './UseOfFunds';
import NoticeNarrative from './NoticeNarrative';
import PerInvestorBreakdown from './PerInvestorBreakdown';
import NotificationPreferences from './NotificationPreferences';
import { CapitalActionNoticeCreatorData } from './useCapitalActionNotice/types';
import { Control, UseFormSetValue } from 'react-hook-form';
import { CreateNoticeSchemaFormValues } from './schema';

type Props = {
  isReadOnly: boolean;
  capitalActionData: CapitalActionNoticeCreatorData;
  formControl: Control<CreateNoticeSchemaFormValues>;
  setValue: UseFormSetValue<CreateNoticeSchemaFormValues>;
};

const DataEntryForm: React.FC<Props> = ({
  isReadOnly,
  capitalActionData,
  formControl,
  setValue,
}) => {
  return (
    <>
      <GeneralInformation
        currencyLcy={capitalActionData.currencyLcy}
        control={formControl}
        readOnly={isReadOnly}
        vehicleId={capitalActionData.vehicleId}
      />
      <Divider />
      {isReadOnly ? null : (
        <>
          <TransactionOverview
            data={capitalActionData.transactionOverview}
            currencyLcy={capitalActionData.currencyLcy}
          />
          <Divider />
        </>
      )}
      {!isReadOnly && capitalActionData.generalCapitalBreakdown?.valueLcy ? (
        <>
          <UseOfFunds
            totalGeneralCall={
              capitalActionData.generalCapitalBreakdown.valueLcy
            }
            currencyLcy={capitalActionData.currencyLcy}
            control={formControl}
            readOnly={isReadOnly}
          />
          <Divider />
        </>
      ) : null}
      <NoticeNarrative control={formControl} readOnly={isReadOnly} />
      <Divider />
      {isReadOnly ? null : (
        <NotificationPreferences setValue={setValue} control={formControl} />
      )}
      {isReadOnly ? (
        <PerInvestorBreakdown
          vehicleId={capitalActionData.vehicleId}
          capitalActionId={capitalActionData.capitalActionId}
          currencyLcy={capitalActionData.currencyLcy}
          control={formControl}
          data={capitalActionData.perInvestorBreakdown}
        />
      ) : null}
    </>
  );
};

export default DataEntryForm;
